import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle} from '@angular/material/dialog';
import {FormsModule} from '@angular/forms';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatButton} from '@angular/material/button';

export interface ReviewCommentDialogData {
  termName: string;
  /** Show Approve + Deny buttons (pending suggestions). */
  canApproveDeny: boolean;
  /** Show Retry-send button (approved suggestions whose TermWeb send failed). */
  canRetrySend: boolean;
}

export interface ReviewCommentDialogResult {
  action: 'approve' | 'deny' | 'send';
  comment?: string;
}

@Component({
  selector: 'pub-review-comment-dialog',
  templateUrl: './review-comment-dialog.component.html',
  styleUrls: ['./review-comment-dialog.component.scss'],
  standalone: true,
  imports: [
    MatDialogTitle, MatDialogContent, MatDialogActions,
    MatFormField, MatLabel, MatInput, MatButton, FormsModule
  ]
})
export class ReviewCommentDialogComponent {
  comment = '';

  title = $localize`:@@review.title:Review "${this.data.termName}:termName:"`;
  approveLabel = $localize`:@@review.action.approve:Approve`;
  denyLabel = $localize`:@@review.action.deny:Deny`;
  sendLabel = $localize`:@@review.action.send:Retry send`;
  cancelButtonLabel = $localize`:@@review.cancel:Cancel`;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ReviewCommentDialogData,
    private dialogRef: MatDialogRef<ReviewCommentDialogComponent>
  ) {}

  approve(): void { this.close('approve'); }
  deny(): void { this.close('deny'); }
  send(): void { this.close('send'); }
  cancel(): void { this.dialogRef.close(undefined); }

  private close(action: 'approve' | 'deny' | 'send'): void {
    const result: ReviewCommentDialogResult = {action};
    // sendToTermWeb takes no comment, so don't include one for retry.
    if (action !== 'send') {
      result.comment = this.comment.trim() || undefined;
    }
    this.dialogRef.close(result);
  }
}
